module.exports = __webpack_public_path__ + "static/media/13.c7797563.png";